import { useState } from "react";

import { useTranslation } from "react-i18next";

import Button from "components/Button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTrigger } from "components/Dialog";
import ImageCreator from "components/ImageCreator";

import type { DeleteItemDialogProps } from "./DeleteItemDialog.types";

export default function DeleteItemDialog({ onConfirm, stamp, signature, logo }: DeleteItemDialogProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button type="button" variant="destructiveOutline" className="w-full">
          {t("button.delete")}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader></DialogHeader>
        {signature && (
          <div className="mb-8">
            <div className="text-sm">
              <ImageCreator
                data={signature}
                alt="preview"
                className="mt-2 max-h-40 object-contain bg-general-gray-300 w-full mb-4"
              />
              <div className="mb-2.5 text-2xl font-semibold text-center">
                {t("profile.deleteItemDialog.deletingOfDigitalSignature")}
              </div>
              <div className="text-base font-normal text-center">
                {t("profile.deleteItemDialog.deletingOfDigitalSignatureConfirmation")}
              </div>
            </div>
          </div>
        )}
        {stamp && (
          <div className="mb-8">
            <div className="text-sm">
              <ImageCreator
                data={stamp}
                alt="preview"
                className="mt-2 max-h-40 object-contain bg-general-gray-300 w-full mb-4"
              />
              <div className="mb-2.5 text-2xl font-semibold text-center">
                {t("profile.deleteItemDialog.deletingOfDigitalStamp")}
              </div>
              <div className="text-base font-normal text-center">
                {t("profile.deleteItemDialog.deletingOfDigitalStampConfirmation")}
              </div>
            </div>
          </div>
        )}
        {logo && (
          <div className="mb-8">
            <div className="text-sm">
              <ImageCreator
                data={logo}
                alt="preview"
                className="mt-2 max-h-40 object-contain bg-general-gray-300 w-full mb-4"
              />
              <div className="mb-2.5 text-2xl font-semibold text-center">{t("profile.deleteItemDialog.deletingOfLogo")}</div>
              <div className="text-base font-normal text-center">
                {t("profile.deleteItemDialog.deletingOfLogoConfirmation")}
              </div>
            </div>
          </div>
        )}
        <DialogFooter className="justify-between gap-2">
          <Button
            type="button"
            variant="destructive"
            className="w-full flex-1"
            onClick={() => {
              setOpen(false);
              onConfirm();
            }}
          >
            {t("button.delete")}
          </Button>

          <Button className="w-full flex-1" type="button" variant="secondary" onClick={() => setOpen(false)}>
            {t("button.cancel")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
